// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .blissey {\n        position: relative;\n        /* TODO: убрать паддинги с рута, доверить их конкретным виджетам */\n        margin: 0 -5px -10px;\n    }\n    .root .blissey_loading {\n        min-height: 152px;\n    }", ""]);
// Exports
module.exports = exports;
